export default "__VITE_ASSET__DL8nS0fm__"